module.exports = __webpack_public_path__ + "media/images/top_countries_map-0e8704e058ff4e168e66eac07529f316.svg";